import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import { Backdrop, CircularProgress, Typography } from '@mui/material';
const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
    zIndex: theme.zIndex.drawer + 1,
    color: theme.palette.primary.main,
    display: 'flex',
    flexDirection: 'column',
}));
const Label = styled(Typography)(({ theme }) => ({
    marginTop: theme.spacing(2),
}));
const CustomBackdrop = ({ label }) => {
    return (_jsxs(StyledBackdrop, Object.assign({ open: true }, { children: [_jsx(CircularProgress, {}), _jsx(Label, Object.assign({ variant: "subtitle1" }, { children: label }))] })));
};
export default CustomBackdrop;
//# sourceMappingURL=index.js.map